const onHoldReason = {
	toBeCancelled: 'to%20be%20cancelled',
	expensiveService: 'expensive%20service%20was%20assigned',
	serviceIsNoLongerAvailable: 'service%20is%20no%20longer%20available',
	throttlingCapped: 'throttling%20capped',
};

export { onHoldReason };
